<template>
  <div>
    <button
      class="btn-primary bg-green border-none leading-snug px-4 py-2 text-white my-2 hover:bg-green-900"
      @click="goToReadingPage"
    >
      Add Reading Element
    </button>
    <Table ref="myTable" :endpoint="endpoint" :tableConfig="tableConfig" />
  </div>
</template>

<script>
import siteConfig from "@/utils/siteConfig"
import Table from "@/components/DataTable/Table"

export default {
  components: { Table },
  data() {
    return {
      siteURL: siteConfig.siteURL,
      tableConfig: [
        {
          header: { textContent: "Name", sortingParam: "name" },
          path: "name",
          classList: "w-1/2",
        },
        { header: { textContent: "Id" }, path: "id" },
        {
          header: {
            textContent: "Reading Time",
            sortingParam: "reading_time",
          },
          path: "reading_time",
          type: "readingTime",
        },
        { header: { textContent: "Tags" }, path: "qtags.length" },
        {
          header: {
            textContent: "Option",
          },

          path: "id",
          type: "action",
          actionButtonText: "Edit",
          routePath: "/reading-edit/:readingId",
        },
      ],
    }
  },
  computed: {
    endpoint() {
      return `${this.siteURL}admin/questions?search_by_type=3&fields=id,name,reading_time,type,is_bonus,qtags`
    },
  },
  methods: {
    goToReadingPage() {
      this.$router.push("/reading-new/")
    },
  },
}
</script>
